export const BrowserStorage = {
  existsLocal(key: string) {
    return !!localStorage.getItem(key)
  },
  removeLocal(key: string) {
    localStorage.removeItem(key)
  },
  readFromLocal<T extends string>(key: string): T | null {
    return localStorage.getItem(key) as T | null
  },
  writeToLocal<T extends string>(key: string, data: T) {
    localStorage.setItem(key, data)
  },
  readLocalObject<T>(key: string): T | null {
    const data = this.readFromLocal(key)
    if (data) return JSON.parse(data)
    return null
  },
  writeLocalObject<T>(key: string, data: T) {
    this.writeToLocal(key, JSON.stringify(data))
  },
  existsSession(key: string) {
    return !!sessionStorage.getItem(key)
  },
  removeSession(key: string) {
    sessionStorage.removeItem(key)
  },
  readFromSession(key: string) {
    return sessionStorage.getItem(key)
  },
  writeToSession<T extends string>(key: string, data: T) {
    sessionStorage.setItem(key, data)
  },
  readSessionObject<T>(key: string): T | null {
    const data = this.readFromSession(key)
    if (data) return JSON.parse(data)
    return null
  },
  writeSessionObject<T>(key: string, data: T) {
    this.writeToSession(key, JSON.stringify(data))
  }
}
